import { readMfeStorageEntry } from '../../helpers/mfeStorage';

// Cookie constants
export const TOOLBAR_COOKIE_NAME = 'flipdish_toolbar_disabled';
export const COOKIE_EXPIRY_DAYS = 365;

// MFE Configuration
export interface MFEConfig {
  windowName: string;
}

export const availableMFEs: MFEConfig[] = [
  { windowName: 'marketing' },
  { windowName: 'finance' },
  { windowName: 'client-reporting' },
  { windowName: 'menu-editor' },
  { windowName: 'menu-editor-v3' },
  { windowName: 'restaurant-menus' },
  { windowName: 'menu-actions' },
  { windowName: 'property-management' },
  { windowName: 'qrop' },
  { windowName: 'admin-tools-micro-frontend' },
  { windowName: 'onboarding-internal-tools' },
  { windowName: 'clients-onboarding' },
  { windowName: 'webhook-service' },
  { windowName: 'entitlements' },
  { windowName: 'restaurant-layout-designer' },
  { windowName: 'fpm-mf' },
  { windowName: 'mobile-apps-tools' },
  { windowName: 'communication' },
  { windowName: 'authorization' },
  { windowName: 'serverless-app-template' },
  { windowName: 'flipdish-agent' },
];

// MFE override URL helper
export const getMfeOverrideUrl = (windowName: string): string | null => {
  const entry = readMfeStorageEntry(windowName);
  return entry?.url ?? null;
};

// Cookie functions
export const setCookie = (name: string, value: string, days: number): void => {
  const date = new Date();
  date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
  const expires = `expires=${date.toUTCString()}`;
  const domain = window.location.hostname;
  document.cookie = `${name}=${value};${expires};domain=${domain};path=/`;
};

export const getCookie = (name: string): string | null => {
  const cookie = document.cookie.split(';').find((c) => c.trim().startsWith(`${name}=`));

  return cookie ? cookie.trim().substring(name.length + 1) : null;
};
